import { Model } from '../general'
import { TriggerState as WorkspaceTriggerState } from './workspace'

export interface Data {
  external_trigger_id: number
  local_start_time: string
  local_end_time: string
  color: number | string
  prio: number
  updated_at: string
}

type TriggerModelData = Data & { id: number }

class Trigger extends Model<TriggerModelData> {
  constructor(parent: any, data: Data) {
    super(parent, { ...data, id: data.external_trigger_id })
  }

  get startTime() {
    return parseDate(this.data.local_start_time)
  }

  get endTime() {
    return parseDate(this.data.local_end_time)
  }

  get colorName() {
    if (typeof this.data.color === 'number') {
      return WorkspaceTriggerState[this.data.color].toLowerCase()
    }
    return this.data.color.toLowerCase()
  }

  get priority() {
    return this.data.prio
  }
}

function parseDate(value: string) {
  return new Date(value.replace(' ', 'T'))
}

export default Trigger
